package com.essntl.features.itinerary.ui.all_itinerary.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryNavigation
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.key.upDownSelection
import com.essntl.uikit.rememberEquals
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun ItineraryListColumn(
    state: AllItineraryState,
    onNavigation: (AllItineraryNavigation) -> Unit,
    itineraryList: List<ItineraryModel>,
    modifier: Modifier = Modifier,
) {
    val lazyListState = rememberLazyListState()
    val scope = rememberCoroutineScope()

    LaunchedEffect(itineraryList) {
        lazyListState.animateScrollToItem(0)
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
    ) {
        LazyColumn(
            verticalArrangement = Arrangement.spacedBy(EsConstants.ListRowVerticalSpacing),
            horizontalAlignment = Alignment.CenterHorizontally,
            contentPadding = PaddingValues(
                vertical = EsConstants.SectionVerticalPadding,
            ),
            state = lazyListState,
            modifier = Modifier
                .fillMaxSize(),
        ) {
            itemsIndexed(itineraryList, key = { _, itinerary -> itinerary.id }) { index, itineraryModel ->
                val isSelected = rememberEquals(itineraryModel.id, setOf(state.selectedItineraryId)) { it }

                val focusRequester = remember { FocusRequester() }

                LaunchedEffect(isSelected) {
                    delay(100L)
                    if (isSelected)
                        focusRequester.requestFocus()
                }

                ItineraryItem(
                    state = state,
                    onNavigation = onNavigation,
                    index = index,
                    itineraryModel = itineraryModel,
                    isSelected = isSelected,
                    modifier = Modifier
                        .upDownSelection(
                            focusRequester = focusRequester,
                            isSelected = isSelected,
                            list = itineraryList,
                            index = index,
                            onSelect = {
                                onNavigation(
                                    AllItineraryNavigation.Overview(
                                        itineraryId = it.id,
                                    ),
                                )
                            },
                            lazyListState = lazyListState,
                            scrollTo = { scope.launch { lazyListState.animateScrollToItem(it) } },
                        ),
                )
            }
        }
    }
}